import { useState } from 'react';
import { useWorkflows } from '../hooks/useWorkflows';
import { WorkflowList } from '../components/WorkflowList';
import { Plus } from 'lucide-react';
import CreateWorkflowModal from '../components/CreateWorkflowModal';

export default function WorkflowsPage() {
  const { workflows, loading, reload } = useWorkflows();
  const [showCreateModal, setShowCreateModal] = useState(false);

  const handleCreateWorkflow = () => {
    setShowCreateModal(true);
  };

  const handleModalClose = () => {
    setShowCreateModal(false);
    reload(); // Recargar la lista después de crear
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="bg-white border-b border-grey-200 px-8 py-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-foreground font-montserrat text-2xl font-bold mb-1">
              Flows
            </h1>
            <p className="text-grey-600 text-sm">
              Gestiona los flujos multimedia de tus agentes
            </p>
          </div>
          <button
            onClick={handleCreateWorkflow}
            className="h-12 px-6 bg-primary hover:bg-primary/90 text-foreground font-montserrat text-sm font-medium rounded-full transition-colors flex items-center gap-2"
          >
            <Plus className="w-5 h-5" />
            Crear Flow
          </button>
        </div>
      </div>

      {/* Content */}
      {loading ? (
        <div className="flex items-center justify-center py-20">
          <p className="text-grey-600">Cargando flows...</p>
        </div>
      ) : (
        <WorkflowList workflows={workflows} onReload={reload} />
      )}

      {/* Modal para crear workflow (reutilizamos CreateAgentModal) */}
      {showCreateModal && (
        <CreateWorkflowModal
          open={showCreateModal}
          onClose={handleModalClose}
          onSuccess={reload}
        />
      )}
    </div>
  );
}
